import { Core } from '../core';
import { SunbedOrderDto, SunbedOrderEntity } from './interfaces';

export const SunbedOrdersStore = Core.Stores.create<SunbedOrderEntity, SunbedOrderDto>(
  '/sunbeds/orders',
);
